// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#law-firm-profile{display:flex;flex-direction:row}#law-firm-profile #full{text-align:center}#law-firm-profile .profile-details-container{flex:7 2 700px;margin-left:20px}#law-firm-profile .v2-btn-icon-link .MuiButton-startIcon{margin-right:5px}@media (max-width: 767px){#law-firm-profile{flex-direction:column}#law-firm-profile .profile-details-container{margin-left:0;margin-top:20px;flex:1 1 auto}}.deleted-view{opacity:.5;pointer-events:none}\n", ""]);
// Exports
module.exports = exports;
